import logo from "../../assets/images/logo.png";
import erasmus from "../../assets/images/erasmus.jpg";
import profilePhoto from "../../assets/images/profile_photo.png";
import { NavLink } from "react-router-dom";
import {
  DashboardOutlined,
  FilePdfOutlined,
  UsergroupAddOutlined,
  MailOutlined,
  LogoutOutlined,
  SolutionOutlined,
  ScheduleOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { use, useEffect, useState } from "react";

function Sidebar() {
  const [user, setUser] = useState({});
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("user")));
  }, []);
  return (
    <>
      <aside className="sidebar">
        <input type="checkbox" id="toggle-chk" name="toggle-chk" />
        <header>
          <NavLink to="/" className="project-title">
            <img src={logo} className="project-logo" />
            <span
              className="project-name"
              title="Project ERASMUS+ RERE Renewable Energy Renewable Earth"
            >
              RERE
            </span>
          </NavLink>
        </header>
        <nav>
          <NavLink to="/">
            <DashboardOutlined />
            <span className="title">Dashboard</span>
          </NavLink>
          <NavLink to="/scenarios">
            <FilePdfOutlined />
            <span className="title">Scenarios</span>
          </NavLink>
          <NavLink
            to="https://drive.google.com/file/d/15JJ9R5xamGCtMwgaCeL-R8aQ72KHkIaU/view?usp=drive_link"
            target="_blank"
          >
            <FilePdfOutlined />
            <span className="title">LMS Guide</span>
          </NavLink>

          {user.role === "teacher" && (
            <NavLink to="/guides">
              <FilePdfOutlined />
              <span className="title">Guides</span>
            </NavLink>
          )}

          {user.role === "teacher" && (
            <NavLink to="/classrooms">
              <SolutionOutlined /> <span className="title">Classrooms</span>
            </NavLink>
          )}
          <NavLink to="/tasks">
            <ScheduleOutlined /> <span className="title">Tasks</span>
          </NavLink>
          <NavLink to="/users">
            <UsergroupAddOutlined />
            <span className="title">Users</span>
          </NavLink>
          <NavLink to="/messages">
            <MailOutlined />
            <span className="title">Messages</span>
          </NavLink>
        </nav>
        <div className="footer-banner">
          <img src={erasmus} />
        </div>
        <footer>
          <div className="current-user">
            <UserOutlined />
            <div className="info">
              <p className="name">{user.username}</p>
              <p className="role">
                <a
                  href="/login"
                  onClick={() => {
                    localStorage.removeItem("user");
                  }}
                >
                  Logout
                </a>
              </p>
            </div>
          </div>

          <label htmlFor="toggle-chk">
            <LogoutOutlined className="toggle-switch" />
          </label>
        </footer>
      </aside>
    </>
  );
}
export default Sidebar;
